import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import Wrapper from 'common/wrapper'
import ReviewModal from 'components/course/review/review-modal'
import { useCourse } from 'querys/course'
import { usePaymentStatus } from 'querys/payment'
import { SecondaryButton } from 'common/button'
import { Typography } from 'common/typography'

const ReviewCardStyled = styled.div`
  padding: 24px;
  border: 1px solid var(--baseSecondary);
  border-radius: 8px;
  .review-description {
    margin: 8px 0 24px;
  }
  @media (min-width: 768px) {
    .review-info {
      display: flex;
    }
    .review-invitation {
      flex-grow: 1;
      margin-right: 16px;
    }
    .review-description {
      margin: 0;
    }
  }
`

function ReviewCard() {
  const { data: { user_review: { stars } } } = useCourse()
  const { data: { has_access } } = usePaymentStatus()
  const { query: { review } } = useRouter()
  const [isActiveModal, setIsActiveModal] = useState(false)
  const handleOpenModal = () => {
    setIsActiveModal(!isActiveModal)
  }
  useEffect(() => {
    if (review === 'open') {
      setTimeout(() => {
        setIsActiveModal(true)
      }, 1000)
    }
  }, [review])
  if (stars > 0 || !has_access) return null
  return (
    <section id="review">
      <Wrapper maxWidth="1200">
        <ReviewCardStyled>
          <div className="review-info">
            <div className="review-invitation">
              <Typography as="h3" small="headline6" large="headline5">
                Valoración del curso
              </Typography>
              <p className="review-description">Déjanos tu opinión para seguir mejorando cada día.</p>
            </div>
            {!isActiveModal && (
              <SecondaryButton onClick={() => handleOpenModal()} fullWidth fitContent>
                Valorar curso
              </SecondaryButton>
            )}
          </div>
          <ReviewModal isActiveModal={isActiveModal} handleClick={handleOpenModal} />
        </ReviewCardStyled>
      </Wrapper>
    </section>
  )
}

export default ReviewCard
